import { InclusionItem } from '~/components/Cruises/types';

import { RateCodeFormValues } from './types';

export const hasRequiredFields = (values: RateCodeFormValues): boolean => {
  return typeof values.isFlash !== 'undefined';
};

export function buildInclusionDepositDetails(inclusionItem: InclusionItem): string {
  const { creditAmount, creditCurrency } = inclusionItem;

  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: creditCurrency,
    maximumFractionDigits: 2,
  }).format(creditAmount);
}
